import AppVue from './AppVue'
import unhandledrejection from './unhandledrejection'


AppVue;

window.addEventListener('unhandledrejection', unhandledrejection );